// Generated by scripts/optimise-images.py
export const imageManifest = {
  "./info_images/SalexLTD.jpeg": {
    "width": 632,
    "height": 625,
    "variants": [
      {
        "url": "./info_images/optimised/SalexLTD-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/SalexLTD-632.webp",
        "width": 632
      }
    ]
  },
  "./info_images/childhoodRobot.jpeg": {
    "width": 1170,
    "height": 866,
    "variants": [
      {
        "url": "./info_images/optimised/childhoodRobot-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/childhoodRobot-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/childhoodRobot-1170.webp",
        "width": 1170
      }
    ]
  },
  "./info_images/cv_model.jpeg": {
    "width": 1529,
    "height": 1664,
    "variants": [
      {
        "url": "./info_images/optimised/cv_model-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/cv_model-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/cv_model-1440.webp",
        "width": 1440
      }
    ]
  },
  "./info_images/floorGeneral.jpeg": {
    "width": 1280,
    "height": 853,
    "variants": [
      {
        "url": "./info_images/optimised/floorGeneral-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/floorGeneral-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/floorGeneral-1280.webp",
        "width": 1280
      }
    ]
  },
  "./info_images/kaPaoTeam.jpeg": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "url": "./info_images/optimised/kaPaoTeam-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/kaPaoTeam-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/kaPaoTeam-1440.webp",
        "width": 1440
      }
    ]
  },
  "./info_images/poolPalApp.png": {
    "width": 2856,
    "height": 1488,
    "variants": [
      {
        "url": "./info_images/optimised/poolPalApp-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/poolPalApp-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/poolPalApp-1440.webp",
        "width": 1440
      }
    ]
  },
  "./info_images/poolPalGroup.jpg": {
    "width": 1200,
    "height": 1200,
    "variants": [
      {
        "url": "./info_images/optimised/poolPalGroup-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/poolPalGroup-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/poolPalGroup-1200.webp",
        "width": 1200
      }
    ]
  },
  "./info_images/poolpallRobot.jpeg": {
    "width": 4032,
    "height": 3024,
    "variants": [
      {
        "url": "./info_images/optimised/poolpallRobot-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/poolpallRobot-960.webp",
        "width": 960
      },
      {
        "url": "./info_images/optimised/poolpallRobot-1440.webp",
        "width": 1440
      }
    ]
  },
  "./info_images/robotAssemblyChildhood.jpg": {
    "width": 960,
    "height": 720,
    "variants": [
      {
        "url": "./info_images/optimised/robotAssemblyChildhood-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/robotAssemblyChildhood-960.webp",
        "width": 960
      }
    ]
  },
  "./info_images/stepHandShake.jpg": {
    "width": 687,
    "height": 584,
    "variants": [
      {
        "url": "./info_images/optimised/stepHandShake-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/stepHandShake-687.webp",
        "width": 687
      }
    ]
  },
  "./info_images/stepProgramme.jpeg": {
    "width": 800,
    "height": 800,
    "variants": [
      {
        "url": "./info_images/optimised/stepProgramme-480.webp",
        "width": 480
      },
      {
        "url": "./info_images/optimised/stepProgramme-800.webp",
        "width": 800
      }
    ]
  }
};
